export default {
  cargando: false,
  documentos: [],
  documentosSeleccionados: [],
  documentoActual: {},
  paginaActual: 1,
  paginasTotales: 1,
  registrosEncontrados: 0,
  registrosPorPagina: 15,
  filtros: {},
  campos: [],
  emision: null
};
